"use strict";

exports.__esModule = true;
exports["default"] = exports.ResultItemBottomBorderStyle = exports.ResultContainer = exports.ProductType = exports.ProductTitle = exports.ProductInfo = exports.ProductImage = exports.ProductDate = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _styles = require("@qc-modules/styles");

var _ramda = require("ramda");

var _propTypes = require("prop-types");

var _cta = _interopRequireDefault(require("../cta"));

var _primitives = _interopRequireDefault(require("../../primitives"));

var _extraInfo = _interopRequireDefault(require("./extra-info"));

var _downloadLinks = _interopRequireWildcard(require("../download-links"));

var _excluded = ["isClickable", "isRestricted", "image"],
    _excluded2 = ["image"],
    _excluded3 = ["isRestricted"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var ResultItemBottomBorderStyle = (0, _styledComponents.css)(["border-bottom:1px solid ", ";"], function (props) {
  return (0, _styles.colors)("gray", props);
});
exports.ResultItemBottomBorderStyle = ResultItemBottomBorderStyle;
var ResultContainer = (0, _styledComponents["default"])(function (_ref) {
  var isClickable = _ref.isClickable,
      isRestricted = _ref.isRestricted,
      image = _ref.image,
      rest = _objectWithoutPropertiesLoose(_ref, _excluded);

  return /*#__PURE__*/_react["default"].createElement(_primitives["default"].Box, rest);
}).withConfig({
  displayName: "result-item__ResultContainer",
  componentId: "sc-1az3glf-0"
})(["display:grid;column-gap:16px;row-gap:8px;border-top:1px solid ", ";border-radius:0;box-shadow:none;text-decoration:none;", " ", " ", " ", " &:hover + section{border-top-color:transparent;}&:last-of-type{", "}"], function (props) {
  return (0, _styles.colors)("gray", props);
}, function (_ref2) {
  var image = _ref2.image;
  return !image ? "@media (max-width: 549px) {\n      grid-template-columns: 100%;\n    }" : "\n    grid-template-columns: auto 1fr;";
}, function (_ref3) {
  var isClickable = _ref3.isClickable;
  return isClickable ? "cursor: pointer;" : null;
}, (0, _styles.transitionEase)("0.2s", ["box-shadow", "border-color", "border-radius"]), function (_ref4) {
  var isRestricted = _ref4.isRestricted;
  return !isRestricted ? "&:hover {\n    border-color: #fff;\n    box-shadow: 2px 4px 20px 0 rgba(0, 0, 0, 0.1);\n    border-radius: 10px;\n  }" : null;
}, ResultItemBottomBorderStyle);
exports.ResultContainer = ResultContainer;
var ProductImage = (0, _styledComponents["default"])(_primitives["default"].Image).withConfig({
  displayName: "result-item__ProductImage",
  componentId: "sc-1az3glf-1"
})(["grid-column:1;grid-row:1 / span 2;object-fit:contain;@media (max-width:549px){grid-row:1;}"]);
exports.ProductImage = ProductImage;
var ButtonCta = (0, _styledComponents["default"])(function (props) {
  return /*#__PURE__*/_react["default"].createElement(_cta["default"], _extends({}, props, {
    mb: 0,
    version: "link"
  }));
}).withConfig({
  displayName: "result-item__ButtonCta",
  componentId: "sc-1az3glf-2"
})(["display:inline-block;font-size:16px;text-align:start;"]);
var ProductTitle = (0, _styledComponents["default"])(function (_ref5) {
  var image = _ref5.image,
      rest = _objectWithoutPropertiesLoose(_ref5, _excluded2);

  return /*#__PURE__*/_react["default"].createElement(_primitives["default"].Text, rest);
}).withConfig({
  displayName: "result-item__ProductTitle",
  componentId: "sc-1az3glf-3"
})(["align-self:center;", ""], function (_ref6) {
  var image = _ref6.image;
  return !image ? "\n      grid-column: 1;\n      grid-row: 1;\n      @media (max-width: 549px) {\n        grid-row: 2;\n  }\n    " : "\n      grid-column: 2;\n      grid-row: 1;\n      ";
});
exports.ProductTitle = ProductTitle;
var ProductInfo = (0, _styledComponents["default"])(_primitives["default"].Box).withConfig({
  displayName: "result-item__ProductInfo",
  componentId: "sc-1az3glf-4"
})(["", ""], function (_ref7) {
  var image = _ref7.image;
  return !image ? "\n      grid-column: 1;\n      grid-row: 2;\n      @media (max-width: 549px) {\n        grid-row: 3;\n      }" : "\n  grid-column: 2;\n  grid-row: 2;\n  @media (max-width: 549px) {\n    grid-column: 1 / span 2;\n  }\n  ";
});
exports.ProductInfo = ProductInfo;
var ProductDate = (0, _styledComponents["default"])(function (_ref8) {
  var isRestricted = _ref8.isRestricted,
      props = _objectWithoutPropertiesLoose(_ref8, _excluded3);

  return /*#__PURE__*/_react["default"].createElement(_primitives["default"].Text, props);
}).withConfig({
  displayName: "result-item__ProductDate",
  componentId: "sc-1az3glf-5"
})(["text-align:right;grid-column:2;grid-row:", ";@media (max-width:549px){text-align:left;grid-column:1;grid-row:1;}"], function (props) {
  return props.isRestricted ? "1" : "1 / span 2";
});
exports.ProductDate = ProductDate;
var ProductType = (0, _styledComponents["default"])(ProductDate).withConfig({
  displayName: "result-item__ProductType",
  componentId: "sc-1az3glf-6"
})(["text-transform:uppercase;cursor:pointer;grid-column:1;"]);
exports.ProductType = ProductType;
var ResultItemBody = (0, _styledComponents["default"])(function (props) {
  return /*#__PURE__*/_react["default"].createElement(_primitives["default"].Text, _extends({
    fontSize: 2,
    letterSpacing: "0.5px",
    lineHeight: 1.3,
    mb: 1
  }, props));
}).withConfig({
  displayName: "result-item__ResultItemBody",
  componentId: "sc-1az3glf-7"
})(["color:", ";"], function (props) {
  return (0, _styles.colors)("body-grey", props);
});
var OverflowBox = (0, _styledComponents["default"])(_primitives["default"].Box).withConfig({
  displayName: "result-item__OverflowBox",
  componentId: "sc-1az3glf-8"
})(["overflow-x:auto;overflow-y:hidden;"]);
var propTypes = {
  /** Text to show when hiding the download options */
  alternateText: _propTypes.string,

  /** The main copy of the result item */
  body: _propTypes.string,

  /** Allows custom styling */
  className: _propTypes.string,

  /** classificaton string */
  classification: _propTypes.string,

  /** Formatted date */
  date: _propTypes.string,

  /** An array of company objects to display as distributors */
  distributors: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
    companies: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
      id: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.number]).isRequired
    })),
    id: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.number]).isRequired,
    region: _propTypes.string
  })),

  /** Default onClick function for each download option */
  downloadAction: _propTypes.func,

  /** An array of download option objects, optionOnClick overrides downloadAction */
  downloadOptions: (0, _propTypes.arrayOf)(_downloadLinks.downloadOptionPropType),

  /** Text for download links group */
  downloadText: _propTypes.string,

  /** Image on the left of the content */
  image: _propTypes.string,

  /**  Boolean used to determine expand/collapse state of ExtraInfo */
  isOpen: _propTypes.bool,

  /**  Control resource restriction */
  isRestricted: _propTypes.bool,

  /** The max character count for description to truncate */
  maxCharCount: _propTypes.number,

  /** Node or string for the purchase button text  */
  purchaseText: _propTypes.node,

  /** Type for the result document */
  resource: _propTypes.string,

  /** onClick handler for result item container */
  resultItemOnClick: _propTypes.func,

  /**  Whether to show or hide the download options */
  showDownloadOptions: _propTypes.bool,

  /** string value id of suite associated with result */
  suiteId: _propTypes.string,

  /** Title for the result document */
  title: _propTypes.string.isRequired,

  /** title onClick handler */
  titleAction: _propTypes.func,

  /** Url for when a result item is a link */
  url: _propTypes.string
};
var defaultProps = {
  isOpen: false,
  isRestricted: false,
  maxCharCount: 250
};

var ResultItem = function ResultItem(_ref9) {
  var alternateText = _ref9.alternateText,
      body = _ref9.body,
      classification = _ref9.classification,
      className = _ref9.className,
      date = _ref9.date,
      distributors = _ref9.distributors,
      downloadAction = _ref9.downloadAction,
      downloadOptions = _ref9.downloadOptions,
      downloadText = _ref9.downloadText,
      image = _ref9.image,
      isOpen = _ref9.isOpen,
      isRestricted = _ref9.isRestricted,
      maxCharCount = _ref9.maxCharCount,
      purchaseText = _ref9.purchaseText,
      resultItemOnClick = _ref9.resultItemOnClick,
      resource = _ref9.resource,
      showDownloadOptions = _ref9.showDownloadOptions,
      suiteId = _ref9.suiteId,
      title = _ref9.title,
      titleAction = _ref9.titleAction,
      url = _ref9.url;
  var description = body || "";
  var truncatedDesc = description.length > maxCharCount ? (0, _ramda.take)(maxCharCount, description) + "..." : description;
  return /*#__PURE__*/_react["default"].createElement(ResultContainer, {
    className: className,
    forwardedAs: url ? "a" : "section",
    href: url,
    image: image,
    isClickable: url || (0, _ramda.is)(Function, resultItemOnClick) && !isOpen,
    isRestricted: isRestricted,
    onClick: url || isOpen ? null : resultItemOnClick,
    px: [3, 3, 2],
    py: 2,
    target: url ? "_blank" : null
  }, !isRestricted && image && /*#__PURE__*/_react["default"].createElement(ProductImage, {
    height: "86px",
    src: image,
    width: "120px"
  }), /*#__PURE__*/_react["default"].createElement(ProductTitle, {
    color: !isRestricted ? "gray-dark" : "text-light-grey",
    fontSize: 3,
    fontWeight: 1,
    image: image,
    letterSpacing: "0.5px",
    onClick: showDownloadOptions && (0, _ramda.is)(Function, titleAction) ? function (event) {
      titleAction({
        suiteId: suiteId
      }, event);
    } : null,
    tag: showDownloadOptions && (0, _ramda.is)(Function, titleAction) ? ButtonCta : "h1"
  }, title), !isRestricted && /*#__PURE__*/_react["default"].createElement(ProductInfo, {
    image: image
  }, body && /*#__PURE__*/_react["default"].createElement(_primitives["default"].RawHtml, {
    html: truncatedDesc,
    tag: ResultItemBody
  }), /*#__PURE__*/_react["default"].createElement(OverflowBox, {
    mt: 1
  }, downloadOptions && /*#__PURE__*/_react["default"].createElement(_primitives["default"].Flex, null, /*#__PURE__*/_react["default"].createElement(_downloadLinks["default"], {
    alternateText: alternateText,
    classification: classification,
    downloadAction: downloadAction,
    downloadOptions: downloadOptions,
    downloadText: downloadText,
    resource: resource,
    showDownloadOptions: showDownloadOptions
  }))), distributors && /*#__PURE__*/_react["default"].createElement(_extraInfo["default"], {
    distributors: distributors,
    isOpen: isOpen,
    purchaseText: purchaseText,
    resultItemOnClick: resultItemOnClick
  })), date && /*#__PURE__*/_react["default"].createElement(ProductDate, {
    color: "text-light-grey",
    fontWeight: 2,
    isRestricted: isRestricted,
    letterSpacing: "0.5px",
    width: 1
  }, date), resource && /*#__PURE__*/_react["default"].createElement(ProductType, {
    color: "legal-grey",
    fontSize: 0,
    fontWeight: 2,
    isRestricted: isRestricted,
    letterSpacing: "1.5px",
    width: 1
  }, resource));
};

ResultItem.propTypes = propTypes;
ResultItem.defaultProps = defaultProps;
ResultItem.displayName = "Modules.ResultItem";
var _default = ResultItem;
exports["default"] = _default;